<ng-container *ngIf="sku">
  <div *ngIf="isRemove" class="sku_action sku_action--error" (click)="removeSku(sku)"> <i class="far fa-times-circle fa-1x"></i>
  </div>
    <div class="sku_image" (click)="previewImage(sku.Image)">
      <img [src]="sku.Image" />
    </div>
    <div class="sku">
      <div class="sku_title" [title]="sku.Title || sku.title">
        {{ sku.Title || sku.title}}
      </div>
      <div class="sku_chips">
        <app-sku-chip
          *ngIf="sku.Sku || sku.sku"
          [name]="'SKU'"
          [value]="sku.Sku || sku.sku"
          [link]="
          accountType === 'amazon'
              ? 'https://sellercentral.amazon.com/myinventory/inventory?searchTerm=' +
              (sku.Sku || sku.sku)
              : 'https://seller.walmart.com/items-and-inventory/manage-items?filters=%7B%22productOfferId%22%3A%7B%22op%22%3A%22is%22%2C%22value%22%3A%5B%7B%22key%22%3A%22sku%22%2C%22value%22%3A%22' +
              (sku.Sku || sku.sku )+
                '%22%7D%5D%7D%7D'
          "
        ></app-sku-chip>
    
        <app-sku-chip
          *ngIf="sku.Asin || sku.asin"
          [name]="'ASIN'"
          [value]="sku.Asin  || sku.asin"
          [link]="
          accountType === 'amazon'
              ? 'https://amazon.com/dp/' + (sku.Asin  || sku.asin) + '?th=1&psc=1'
              : 'https://www.walmart.com/ip/' + (sku.Asin  || sku.asin) + '/?selected=true'
          "
        ></app-sku-chip>        

        <app-sku-chip
        *ngIf="sku.FnSku || sku.fnSku"
        [name]="'FNSKU'"
        [value]="sku.FnSku || sku.fnSku"
      ></app-sku-chip>
      </div>
    </div>
    <div class="sku_label_text" *ngIf="sku.Prep || sku.prep">{{(sku.Prep || sku.prep) | titlecase}}</div>
    <div class="sku_actions" *ngIf="isRemove">
      <div class="input-container" *ngIf="isCaseQty" >
        <label class="input-container_label">Cases</label>
        <input
        numbersOnly
        type="number"
        class="input-container_input input-container_input--small case-qty"
        [min]="1"
        (input)="caseQtyChanged($event)"
        [formControl]="caseQtyInput" 
        />

        
      </div>
      <div class="input-container">
        <label class="input-container_label">{{isCaseQty ? 'Qty Per Case' : 'Total Qty'}}</label>
        <input
        numbersOnly
        type="number"
        class="input-container_input input-container_input--small case-qty"
        [min]="sku.minQty || 1"
        [formControl]="qtyInput"
        (input)="updateQty($event)"
        [value]="qtyInput"
        >
        <div *ngIf="isCaseQty && qtyInput.errors" class="qtyInput-error">
          <div>            
            <span *ngIf="qtyInput.errors.max">
              <span>&#9888;</span>
             Qty can't be more than 150 per case.
            </span>
          </div>
        </div>
      </div>

      <div class="input-container ps-3" *ngIf="isCaseQty">
        <label class="input-container_label">Total</label>
        <div class="totalQty">{{caseQtyInput.value * qtyInput.value}}</div>
      </div>
    </div>
    </ng-container>